import type { MessageKey } from './i18n'
import type { Person } from './types'

/** Up to two letters of a name, for an avatar. */
export function initials(name: string): string {
  const letters = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => [...word][0]!)
  return letters.join('').toUpperCase() || '?'
}

/** A name with the titles its user gives on their profile, as in "Prof. Dr. Ada Example, PhD". */
export function fullName({ name, honorific_prefix, honorific_suffix }: Pick<Person, 'name' | 'honorific_prefix' | 'honorific_suffix'>): string {
  const titled = [honorific_prefix, name].filter(Boolean).join(' ')
  return honorific_suffix ? `${titled}, ${honorific_suffix}` : titled
}

/**
 * What stands beside a user's name: their sites or that they learn, and whether they moderate the forum (FOR-08).
 * Each once: two sites may share a name.
 */
export function standing(person: Person, t: (key: MessageKey) => string): string[] {
  return [...new Set([...person.sites, ...(person.learner ? [t('forumLearner')] : []), ...(person.moderator ? [t('forumModerator')] : [])])]
}

export const profilePath = (userId: string) => `/people/${userId}`
